var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPackageSellWithUs = function SvgPackageSellWithUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 201 175",
    style: {
      enableBackground: "new 0 0 201 175"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.1 3.4H25.9l-17 47.2h183.3zM5.9 58.6v111.2H195V58.6H5.9zm53.6 59.3c0 8.6-6 16-14.4 17.8v11.7H55v7.6H27.7v-7.6h9.8v-11.8c-8.4-1.8-14.4-9.2-14.4-17.8V99.7h36.3v18.2zm47.7 6.8v18.9c0 6.3-5.1 11.3-11.4 11.3-6.3 0-11.3-5.1-11.3-11.3V136H92v7.6c0 2.1 1.7 3.8 3.8 3.8 2-.1 3.6-1.8 3.8-3.8v-18.9H79.9V119C81 106.9 91.3 97.4 103 97.4c12.9.1 23.4 10.5 23.5 23.5v3.8h-19.3zm67.3 30.6h-27.2v-7.6h27.2v7.6zm-2.6-31-7.2-7.2V144h-7.6v-26.9l-7.2 7.2-5.3-5.3 16.3-16.3 16.3 16.2-5.3 5.4z"
  })));
};
export default SvgPackageSellWithUs;